import React, { useEffect, useContext } from "react";

import UserContext from "../../../components/User_Context.js";

import * as menu from "../../../assets/menus/menu.js";

import ChatScreenInputBox from "./chat_screen_input_box.jsx";
import UserChatMessage from "./messages/user_chat_message.jsx";
import AiChatMessage from "./messages/ai_chat_message.jsx";

import CurrentQuestionMessage from "./messages/current_question_message.jsx";
import LoadingMessage from "./messages/loading_message.jsx";
import LastAiMessage from "./messages/last_ai_message.jsx";
import ChatHistorySidebar from "./chat_history_sidebar.jsx";
import ChatDocumentsSidebar from "./chat_documents_sidebar.jsx";
import ChatSettingsSidebar from "./chat_settings_sidebar.jsx";
import ChatWelcomeMessage from "./messages/chat_welcome_message.jsx";
import LoadingScreenAnimation from "../../../components/loading_screen_animation.jsx";
import { ChatProvider, useChatContext } from "./chat_context.jsx";

function NewChatScreenContent() {
  const { currentUser } = useContext(UserContext);
  const {
    fileInfo,
    folderInfo,
    history,
    setHistory,
    toAddInTheHistory,
    setToAddInTheHistory,
    currentQuestion,
    setCurrentQuestion,
    isStreaming,
    setIsStreaming,
    headerHeight,
    showSettings,
    initializeChat,
    messagesEndRef,
    chatContainerRef,
  } = useChatContext();

  // Initialize chat on component mount
  useEffect(() => {
    (async () => {
      // Step 1: Write menu with user and language
      menu.write({ user: currentUser(), language: process.env.LANGUAGE });

      // Step 2: Initialize chat (this includes getting user chat nodes, file/folder info, and starting chat)
      await initializeChat();
    })();
  }, []);

  // ChatGPT-style Layout Component
  const renderChatGPTLayout = () => {
    return (
      <div
        className="chat-container"
        style={{
          height: `calc(100vh - ${headerHeight}px)`,
          display: "flex",
          flexDirection: "column",
          backgroundColor: "#f8f9fa",
          position: "relative",
        }}
      >
        <ChatHistorySidebar />
        <ChatSettingsSidebar />
        <ChatDocumentsSidebar />
        {/* Settings Modal */}

        {showSettings && (
          <div
            className="modal-backdrop fade show"
            style={{ display: "none" }}
          ></div>
        )}

        {/* Area messaggi scrollabile */}
        <div
          ref={chatContainerRef}
          className="chat-messages-container"
          style={{
            flex: 1,
            overflowY: "auto",
            overflowX: "hidden",
            backgroundColor: "#ffffff",
            padding: "1rem",
            scrollBehavior: "smooth",
          }}
        >
          {/* Welcome Message */}
          {history.length === 0 && !currentQuestion && !isStreaming && (
            <ChatWelcomeMessage />
          )}

          {/* Chat Messages */}
          <div className="chat-messages">
            {/* Previous Messages */}
            {[...history].reverse().map((message, index) => (
              <div key={message.id || index} className="mb-4">
                {/* User Message */}
                <UserChatMessage message={message} />

                {/* AI Response */}
                <AiChatMessage
                  message={message}
                  history={history}
                  setHistory={setHistory}
                  toAddInTheHistory={toAddInTheHistory}
                  setToAddInTheHistory={setToAddInTheHistory}
                  setIsStreaming={setIsStreaming}
                  setCurrentQuestion={setCurrentQuestion}
                />
              </div>
            ))}

            {/* Current Streaming Question & Answer */}
            {(currentQuestion || isStreaming) && (
              <div className="mb-4">
                {/* Current User Message */}
                {currentQuestion && <CurrentQuestionMessage />}

                {/* Current AI Response */}
                {isStreaming && <LoadingMessage />}

                {/* Show answer with actions when completed streaming */}
                {toAddInTheHistory && !isStreaming && <LastAiMessage />}
              </div>
            )}
          </div>

          <div ref={messagesEndRef} />
        </div>

        {/* Barra input fissa in basso - RELATIVA al container */}
        <ChatScreenInputBox />
      </div>
    );
  };

  // Hide footer in chat
  useEffect(() => {
    const footer = document.querySelector(".footer");
    if (footer) footer.style.display = "none";

    return () => {
      if (footer) footer.style.display = "";
    };
  }, []);

  return (
    <>
      <style>{`
        @keyframes typing {
          0%, 80%, 100% {
            transform: scale(0.8);
            opacity: 0.5;
          }
          40% {
            transform: scale(1);
            opacity: 1;
          }
        }
        
        /* Hide footer in chat */
        .footer {
          display: none !important;
        }
        
        /* Smooth scrolling for chat messages */
        .chat-messages {
          scroll-behavior: smooth;
        }
      `}</style>
      {fileInfo ?? folderInfo ? (
        renderChatGPTLayout()
      ) : (
        <LoadingScreenAnimation />
      )}
    </>
  );
}

function NewChatScreen() {
  const { currentUser } = useContext(UserContext);

  return (
    <ChatProvider currentUser={currentUser}>
      <NewChatScreenContent />
    </ChatProvider>
  );
}

export { NewChatScreen };
